export const API = {
  READ_CLUSTER: 'clusters',
  ADD_CLUSTER: 'clusters',
  VIEW_PROJECT: 'clusters/',
  VIEW_CLUSTER_ID: 'clusters/',
  VIEW_PROJECT_ID: '/projects/',
  VIEW_REPORT_ANALYSIS: 'reports/',
  SIGN_UP: 'register',
  VERIFY_EMAIL: 'emailverification',
  CONTACT_QUERY:'contactdjuli',
  RESEND_EMAIL:'sendemailverificationlink',
  RESET_PASSWORD:'resetpassword',
  UPDATE_CLUSTER: 'clusters/',
  UPDATE_PROJECT: 'projects/',
  FETCH_PLANS:'plans',
  USER_TYPE_BASED_PLAN:'filterPlans',
  CREATE_SUBSCRIPTION:'subscriptions',
  PAYMENT_INTENT:'intent',
  FETCH_SAVED_CARD:'wallet',
  LIST_SUBSCRIPTION:'subscriptions',
  CANCEL_SUBSCRIPTION:'subscriptions',
  DELETE_CARD:'deletecard',
  TRANSACTION_HISTORY:'billinghistory',
  CREATE_CLUSTER_PROJECT:'cluster/',
  CREATE_PROJECT:'/project',
  CREATE_REPORT:'/report',
  CREATE_PROJECT_REPORT:'/projects',
  SHARE_CLUSTER:'shareclusters/',
  SHARE_PROJECT:'shareprojects/',
  USER_PROFILE:'profile/',
  USER_DETAILS:'userdetails',
  VALIDATE_FREEMIUM:'freemium_status',
  SUBSCRIBE_FREEMIUM:'freemium_status',
};
